<div class="ai-analyst">

	<!-- Saved-session sidebar -->
	<aside class="ai-analyst__sidebar">
		<button type="button" class="ai-analyst__new" (click)="newChat()">
			<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
				<path d="M12 5v14M5 12h14"></path>
			</svg>
			New chat
		</button>

		<div class="ai-analyst__sessions">
			<button type="button" class="ai-analyst__session"
					*ngFor="let session of sessions"
					[class.ai-analyst__session--active]="session.startUtc === activeStartUtc"
					(click)="openSession(session)">
				<span class="ai-analyst__session-title">{{ session.title }}</span>
				<span class="ai-analyst__session-archive" title="Archive"
					  (click)="archiveSession($event, session)" aria-label="Archive">
					<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
						<path d="M21 8v13H3V8M1 3h22v5H1zM10 12h4"></path>
					</svg>
				</span>
			</button>
		</div>
	</aside>

	<!-- Conversation -->
	<main class="ai-analyst__main">
		<cs-chat
			[title]="chatTitle"
			[titleEditable]="!!activeStartUtc"
			[messages]="messages"
			[busy]="busy"
			[contextUsage]="contextUsage"
			(send)="onSend($event)"
			(stop)="onStop()"
			[debugEnabled]="canDebug"
				[debugContext]="debugContext"
				(debugRequested)="onDebugRequested()"
				(titleChange)="onRenameTitle($event)"></cs-chat>
	</main>
</div>
